import script from "./WegowButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowButton.vue?vue&type=script&setup=true&lang=js"

import "./WegowButton.vue?vue&type=style&index=0&id=b691bddc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b691bddc"]])

export default __exports__